import React from "react";
import { color } from "@ui";
import { styled } from "@linaria/react";
import Button from "@ui/Button";
import t from "../../i18n";

interface P {
  showUnread: () => void;
  unreadCount: number;
}

const StyledButton = styled(Button)`
  background-color: ${color.phosphorus50};
  color: ${color.phosphorus800};
  &&&:hover {
    background-color: ${color.phosphorus200};
    color: ${color.phosphorus900};
  }
`;

const RefreshButton = ({ showUnread, unreadCount }: P) => (
  <StyledButton
    onClick={showUnread}
    variant="ghost"
    slim
    title={t("activitities.refresh.tooltip", { count: unreadCount })}
  >
    {t("button.refresh")}
  </StyledButton>
);

export default RefreshButton;
